import * as React from "react";
import type { SVGProps } from "react";
const SvgWheelchair = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M8.09 6.858a3 3 0 1 1 2.004-.065L10.34 9H16.5a1 1 0 1 1 0 2h-5.938l.326 2.939 6.545-.437a1 1 0 0 1 1.032.735L19.764 19h.736a1 1 0 0 1 0 2H19a1 1 0 0 1-.965-.737l-1.285-4.71-6.683.445a1 1 0 0 1-1.06-.887zm.203-3.565a1 1 0 1 1 1.414 1.414 1 1 0 0 1-1.414-1.414"
        clipRule="evenodd"
      />
      <path d="M7.409 10.127a1 1 0 0 1-.492 1.326 5.001 5.001 0 1 0 6.926 5.798 1 1 0 1 1 1.936.498A7.002 7.002 0 0 1 2 16a7 7 0 0 1 4.083-6.365 1 1 0 0 1 1.326.492" />
    </g>
  </svg>
);
export default SvgWheelchair;
